import { selectFavouritesSummary, selectIsFavourite } from '@noths/polaris-client-user-favourites';
import { createSelector } from '@reduxjs/toolkit';

import { selectProduct } from 'src/redux/product/selectors';

export const selectFavouriteProduct = createSelector(
  [selectFavouritesSummary, selectProduct],
  (favouritesSummary, product) => {
    return selectIsFavourite(favouritesSummary, product.code);
  },
);
